import BackToTopArrow from './BackToTopArrow';

export default BackToTopArrow;
